import { FC } from "react";

interface ModalContentProps {
    onClose: () => void;
    onReset: () => void;
}

const ModalContent: FC<ModalContentProps> = ({ onClose, onReset }) => {
    return (
        <div className="modalContent">
            <div className="modalBody">
                <h2>Restart Conversation</h2>
                <p>
                    Would you like to refresh and return to the starting point of the conversation?
                </p>
            </div>

            <div className="modalActions">
                <button onClick={onClose} className="cancelBtn">
                    Cancel
                </button>

                <button onClick={onReset} className="restartBtn">
                    Restart
                </button>
            </div>
        </div>
    );
};

export default ModalContent;
